import { SYSTEM_STORAGE_NAMES } from '../constants'
import { Storage } from '@feedyou/schema'

export const getSystemStorages = (): Storage[] => {
  return SYSTEM_STORAGE_NAMES.map(name => {
    return {
      name: name,
      storageType: ['system']
    }
  })
}
